export default "__VITE_ASSET__CjX0j0o2__"